import {useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {useState} from 'react';

import {register} from '@/store/authSlice.ts';
import {useAppDispatch} from '@/hooks/redux.ts';

import {Button} from "@/components/ui/Button.tsx";
import {Toast} from "@/components/ui/Toast.tsx";
import {
    Container,
    Form,
    Label,
    Input,
    ErrorMessage,
    LoginLink
} from '@/components/auth/styles/RegisterForm.styles';
import {ToastState} from "@/components/auth/types/register.types.ts";

import {AssistantLabTitle} from "@/assets/Logos.tsx";
import {StyledTable} from "@/components/auth/styles/LoginForm.styles.ts";


export const RegisterForm = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {register: registerField, handleSubmit, formState: {errors}} = useForm();
    const [toast, setToast] = useState<ToastState>({
        show: false,
        message: '',
        type: 'success'
    });

    const onSubmit = async (data: any) => {
        try {
            await dispatch(register(data)).unwrap();
            setToast({
                show: true,
                message: 'Регистрация прошла успешно! Пожалуйста, проверьте свою электронную почту, чтобы подтвердить свою учетную запись.',
                type: 'success'
            });
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err: any) {
            setToast({
                show: true,
                message: err.message || 'Регистрация не удалась. Пожалуйста, попробуйте еще раз.',
                type: 'error'
            });
        }
    };

    return (
        <Container>
            {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(prev => ({...prev, show: false}))}
                />
            )}
            <Form onSubmit={handleSubmit(onSubmit)}>
                <StyledTable>
                    <tr>
                        <td/>
                        <AssistantLabTitle/>
                    </tr>
                    <tr>
                        <td><Label>Your name</Label></td>
                        <td>
                            <Input
                                type="text"
                                {...registerField('name', {required: 'Name is required'})}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><Label>Email</Label></td>
                        <td>
                            <Input
                                type="email"
                                {...registerField('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Invalid email address'
                                    }
                                })}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td/>
                        <td>
                            {(errors.name || errors.email) && (
                                <ErrorMessage>
                                    {(errors.name?.message || errors.email?.message) as string}
                                </ErrorMessage>
                            )}

                            <Button type="submit" variant="primary" style={{width: '110px'}}>
                                Sign up
                            </Button>
                        </td>
                    </tr>
                    <tr>
                        <td/>
                        <td>
                            <LoginLink to="/login">Sign in</LoginLink>
                        </td>
                    </tr>
                </StyledTable>
            </Form>
        </Container>

    );
};
